<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/apBWFA/tc-custom/9781467423755.jpg?1731796457421" alt="This image is the cover for the book Philippians, Two Horizons New Testament Commentary (THNTC)"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Philippians, Two Horizons New Testament Commentary (THNTC)
      </h1>
      <p class="bookDescription body article font2">
        <p>In this fine new commentary on Paul's letter to the Philippians, Stephen Fowl notes that for the great premodern commentators of the Christian tradition, the literal sense of Scripture is always regulated by theological concerns. Thus, unlike commentaries that simply append theology to historical criticism, Fowl's volume displays disciplined attention to the text of Philippians in ways that enhance rather than frustrate theological inquiry.<br/><br/> While Fowl engages the great scholars of the past, John Chrysostom and Thomas Aquinas among them, he also draws a novel theology of friendship from Paul's letter and unpacks how the teachings of Philippians might be embodied today by Christians in the West.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stephen E. Fowl
      </h2>
      
      <p class="authorDescription body article">Stephen E. Fowl is professor of theology at Loyola College in Maryland. His previous books include <em>The Story of Christ in the Ethics of Paul, Reading in Communion</em> (with L. Gregory Jones), and <em>Engaging Scripture</em>."</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?160908e0